var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEvidence(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979AAF",
    stroke: "#979AAF",
    strokeWidth: 0.3,
    d: "M1.35 1c-.19.02-.35.214-.35.423v14.365c0 .221.184.423.386.423h16.228c.202 0 .386-.202.386-.423V1.423C18 1.2 17.816 1 17.614 1H1.35zm.423.845h15.454V13.22l-3.386-4.06c-.078-.09-.195-.14-.308-.132-.052.002-.104.015-.151.04l-5.053 2.766-2.016-2.456c-.086-.107-.223-.16-.35-.139-.04.007-.08.02-.115.04L1.773 11.51V1.845zm7.34 2.535c-1.062 0-1.931.951-1.931 2.113 0 1.161.87 2.112 1.932 2.112 1.062 0 1.931-.95 1.931-2.112 0-1.162-.869-2.113-1.931-2.113zm0 .845c.645 0 1.16.563 1.16 1.268 0 .705-.515 1.267-1.16 1.267-.644 0-1.158-.562-1.158-1.267 0-.705.514-1.268 1.159-1.268zm4.36 4.747l3.754 4.496v.897h-6.006l-2.36-2.878 4.611-2.515zm-7.54.211l4.243 5.182H1.773v-2.904l4.16-2.278z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvidence);
export default __webpack_public_path__ + "static/media/icon-evidence.74d68aa6c83e59f7290aaaf3cb216153.svg";
export { ForwardRef as ReactComponent };